import { STATS_API } from "@/constants/env";
import useSesamyAuthFetch from "@/hooks/use-sesamy-auth-fetch";
import useSWR from "swr";

type BadgesResponse = {
  manualPayments: {
    total: number;
    unsent: number;
    unpaid: number;
  };
};

export default function useBadges() {
  const { fetcher, isReady } = useSesamyAuthFetch();

  const { data } = useSWR<BadgesResponse>(
    isReady && `${STATS_API}/badges`,
    fetcher,
    { refreshInterval: 60_000 },
  );

  return { badges: data };
}
